const colors = {
	primary: "#009951",
	input: "#f0f5f7",
	white: '#ffff',
	confirmMessage: "#3085d6",
	cancel: "#d33",
	border: "#b5b2b2"
};
export default colors;
